/**
 * Parse /routes/:routePath slugs (e.g. ahmedabad-to-surat-cab) into city slugs.
 */
export function parseRoutePathToSlugs(routePath) {
  if (!routePath || typeof routePath !== "string") return null
  const trimmed = routePath.replace(/-cab$/i, "")
  const parts = trimmed.split("-to-")
  if (parts.length !== 2 || !parts[0]?.trim() || !parts[1]?.trim()) return null
  return {
    fromCity: parts[0].trim().toLowerCase(),
    toCity: parts[1].trim().toLowerCase(),
  }
}

function formatSlugToCityName(slug) {
  if (!slug || typeof slug !== "string") return ""
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ")
}

/**
 * Resolve display labels from get_city_pages when available; else title-case from slug.
 */
export async function resolveRouteCityLabels(fromSlug, toSlug) {
  const fallbackFrom = formatSlugToCityName(fromSlug)
  const fallbackTo = formatSlugToCityName(toSlug)
  const backendUrl =
    (typeof process !== "undefined" && process.env?.REACT_APP_BACKEND_URL) ||
    "https://customerapi.pulpitcabs.com"

  const fetchCityName = async (slug) => {
    if (!slug) return null
    try {
      const res = await fetch(`${backendUrl}/website/get_city_pages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ city_slug: String(slug).toLowerCase() }),
      })
      if (!res.ok) return null
      const json = await res.json()
      const name = json?.data?.city_data?.cityName
      return typeof name === "string" && name.trim() ? name.trim() : null
    } catch {
      return null
    }
  }

  const [fromN, toN] = await Promise.all([
    fetchCityName(fromSlug),
    fetchCityName(toSlug),
  ])

  return {
    from: fromN || fallbackFrom,
    to: toN || fallbackTo,
  }
}
